import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useStore } from '../../contexts/store-provider';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import { IDetailProps } from '../../models/forms/IForm';
import { ITrayVM } from '../../models/response/ITrayResponse';
import { formatMessage } from '../../translations/format-message';

const TrayDetails = (props: IDetailProps) => {
  const { trayManagementStore } = useStore();
  const { GetTrayByIdService, trayDetails } = trayManagementStore;
  const trayDetail: ITrayVM = trayDetails;

  useEffect(() => {
    if (props.selectedRowId > 0) {
      GetTrayByIdService(
        Number(getTenantIdFromLocalStorage()),
        props.selectedRowId
      );
    }
  }, [props.selectedRowId]);

  return (
    <>
      <div className="px-4 py-3">
        <h4 className="pb-3">{formatMessage('order_details')}</h4>
        <div className="row g-2">
          <div className="col-6">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'tray_id'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">{trayDetail.TrayId}</h3>
            </div>
          </div>
          <div className="col-6">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'customer_id'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">{trayDetail.CustomerId}</h3>
            </div>
          </div>
          <div className="col-12">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'end_user_name'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">{trayDetail.EndUserName || 'N/A'}</h3>
            </div>
          </div>
          <div className="col-6">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'end_user_order_id'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">
                {trayDetail.EndUserOrderId || 'N/A'}
              </h3>
            </div>
          </div>
          <div className="col-6">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'order_id'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">{trayDetail.OrderId || 'N/A'}</h3>
            </div>
          </div>
          <div className="col-12">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'sub_contractor'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">{trayDetail.SubContractor || 'N/A'}</h3>
            </div>
          </div>
          <div className="col-12">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'sub_contractor_name'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">
                {trayDetail.SubContractorName || 'N/A'}
              </h3>
            </div>
          </div>
          <div className="col-12">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'katashiki_1'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">{trayDetail.Katashiki1 || 'N/A'}</h3>
            </div>
          </div>
          <div className="col-6">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'katashiki_2'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">{trayDetail.Katashiki2 || 'N/A'}</h3>
            </div>
          </div>
          <div className="col-6">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'kishu'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">{trayDetail.Kishu || 'N/A'}</h3>
            </div>
          </div>
        </div>
      </div>
      <hr className="hr-border mt-3" />
      <div className="px-4">
        <h4 className="pb-3 mt-0">{formatMessage('product_details')}</h4>
        <div className="row g-2">
          <div className="col-6">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'product_id'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">{trayDetail.ProductName || 'N/A'}</h3>
            </div>
          </div>
          <div className="col-6">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'process_name'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">{trayDetail.ProcessName || 'N/A'}</h3>
            </div>
          </div>
          <div className="col-6">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'quantity'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">{trayDetail.Quantity || 'N/A'}</h3>
            </div>
          </div>
          <div className="col-6">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'invoice_number'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">{trayDetail.InvoiceNumber || 'N/A'}</h3>
            </div>
          </div>
          <div className="col-6">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'quantity_unit_name'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">
                {trayDetail.QuantityUnitName || 'N/A'}
              </h3>
            </div>
          </div>
          <div className="col-6">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'missing_parts'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">
                <div className="badge btn-danger">
                  {trayDetail.MissingParts || 'N/A'}
                </div>
              </h3>
            </div>
          </div>
          <div className="col-6">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'tag_id'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">{trayDetail.TagId || 'N/A'}</h3>
            </div>
          </div>
        </div>
      </div>
      <hr className="hr-border mt-3" />
      <div className="px-4">
        <h4 className="mt-0">{formatMessage('comment')}</h4>
      </div>
      <div className="product-comment  mb-3">
        <div className="px-4 py-3">
          <div className="row g-2">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'product_comment_1'} />{' '}
              </p>
              <div className="p-2 rounded comment-box mt-1">
                <h3 className="mt-1 mb-0">
                  {trayDetail.ProductComment1 || 'N/A'}
                </h3>
              </div>
            </div>
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'product_comment_2'} />{' '}
              </p>
              <div className="p-2 rounded comment-box mt-1">
                <h3 className="mt-1 mb-0">
                  {trayDetail.ProductComment2 || 'N/A'}
                </h3>
              </div>
            </div>
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'product_comment_3'} />{' '}
              </p>
              <div className="p-2 rounded comment-box mt-1">
                <h3 className="mt-1 mb-0">
                  {trayDetail.ProductComment3 || 'N/A'}
                </h3>
              </div>
            </div>
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'product_comment_4'} />{' '}
              </p>
              <div className="p-2 rounded comment-box mt-1">
                <h3 className="mt-1 mb-0">
                  {trayDetail.ProductComment4 || 'N/A'}
                </h3>
              </div>
            </div>
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'product_comment_5'} />{' '}
              </p>
              <div className="p-2 rounded comment-box mt-1">
                <h3 className="mt-1 mb-0">
                  {trayDetail.ProductComment5 || 'N/A'}
                </h3>
              </div>
            </div>
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'product_comment_6'} />{' '}
              </p>
              <div className="p-2 rounded comment-box mt-1">
                <h3 className="mt-1 mb-0">
                  {trayDetail.ProductComment6 || 'N/A'}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-4">
        <h4 className="pb-3 mt-0">{formatMessage('due_dates')}</h4>
        <div className="row g-2">
          <ul className="customer_due_date">
            <li className="">
              <small className="title_sidebar">
                <FormattedMessage id={'customer_due_date'} />{' '}
              </small>
              <h3 className="mt-1 mb-0">
                {trayDetail.CustomerDueDate || 'N/A'}
              </h3>
            </li>
            {/* <li className="">
              <small className="title_sidebar">
                <FormattedMessage id={'planned_due_dates'} />{' '}
              </small>
              <h3 className="mt-1 mb-0">{trayDetail.PlanedDueDate || 'N/A'}</h3>
            </li> */}
          </ul>
        </div>
      </div>
    </>
  );
};

export default observer(TrayDetails);
